[
  {
    "gtin": "01000001",
    "name": "Apple Juice",
    "brandName": "FreshFarms",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 1.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744825853/products/pim/8700216013345-4067768/gillette-intimate-anti-scheuer-stick-intimate",
    "imageOutline": {
      "x0": 0.265,
      "y0": 0.0,
      "x1": 0.735,
      "y1": 1.0,
      "aspect": 0.47
    },
    "placements": [
      {
        "shelfId": "VBK4",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4eb9"
      },
      {
        "shelfId": "H9YO",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4e91"
      },
      {
        "shelfId": "U0ES",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4e9a"
      }
    ],
    "inventory": {
      "quantity": 41
    }
  },
  {
    "gtin": "01000002",
    "name": "Banana Chips",
    "brandName": "SnackCo",
    "baseCategory": "Snacks",
    "reportedPrice": {
      "amount": 1.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.59,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744968742/products/pim/4066447366129-2046346204/balea-bodybalsam-sensitive",
    "imageOutline": {
      "x0": 0.305,
      "y0": 0.0,
      "x1": 0.685,
      "y1": 1.0,
      "aspect": 0.38
    },
    "placements": [
      {
        "shelfId": "VBK4",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4ea4"
      },
      {
        "shelfId": "DEZN",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4ec1"
      }
    ],
    "inventory": {
      "quantity": 0
    }
  },
  {
    "gtin": "01000003",
    "name": "Carrot Cake",
    "brandName": "SweetTreats",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 2.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744985174/products/pim/7610700600054-312127183/ricola-bonbon-original-kraeuterzucker",
    "imageOutline": {
      "x0": 0.115,
      "y0": 0.0,
      "x1": 0.89,
      "y1": 1.0,
      "aspect": 0.775
    },
    "placements": [
      {
        "shelfId": "3WYZ",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4ee4"
      },
      {
        "shelfId": "SCAP",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4ec4"
      },
      {
        "shelfId": "IFRD",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4f35"
      }
    ],
    "inventory": {
      "quantity": 41
    }
  },
  {
    "gtin": "01000004",
    "name": "Dairy Milk",
    "brandName": "MilkyWay",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 0.89,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744963376/products/pim/4066447365443-1772530209/balea-professional-conditioner-oil-repair-intensiv",
    "imageOutline": {
      "x0": 0.265,
      "y0": 0.0,
      "x1": 0.735,
      "y1": 1.0,
      "aspect": 0.47
    },
    "placements": [
      {
        "shelfId": "UJGZ",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4fe0"
      },
      {
        "shelfId": "QC7U",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff500e"
      }
    ],
    "inventory": {
      "quantity": 2
    }
  },
  {
    "gtin": "01000005",
    "name": "Egg Noodles",
    "brandName": "NoodleNest",
    "baseCategory": "Pasta & Noodles",
    "reportedPrice": {
      "amount": 1.79,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.89,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745000509/products/pim/8710447492239-111425826/rexona-antitranspirant-deospray-active-morning",
    "imageOutline": {
      "x0": 0.37,
      "y0": 0.0,
      "x1": 0.635,
      "y1": 1.0,
      "aspect": 0.265
    },
    "placements": [
      {
        "shelfId": "SCAP",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4ec5"
      },
      {
        "shelfId": "IFRD",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4f70"
      },
      {
        "shelfId": "7YSF",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff5066"
      }
    ],
    "inventory": {
      "quantity": 37
    }
  },
  {
    "gtin": "01000006",
    "name": "Fig Bars",
    "brandName": "HealthySnacks",
    "baseCategory": "Snacks",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744804351/products/pim/4011700432301-2035551/tabac-original-after-shave-lotion",
    "imageOutline": {
      "x0": 0.26,
      "y0": 0.0,
      "x1": 0.745,
      "y1": 1.0,
      "aspect": 0.485
    },
    "placements": [
      {
        "shelfId": "8SMF",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff5094"
      },
      {
        "shelfId": "ZQ0I",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3d3d9bab0f83ff50c2"
      }
    ],
    "inventory": {
      "quantity": 0
    }
  },
  {
    "gtin": "01000007",
    "name": "Grape Soda",
    "brandName": "FizzPop",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.09,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745001518/products/pim/8720181291890-1814439390/dove-antitranspirant-deospray-advanced-care-summer-care",
    "imageOutline": {
      "x0": 0.385,
      "y0": 0.0,
      "x1": 0.62,
      "y1": 1.0,
      "aspect": 0.235
    },
    "placements": [
      {
        "shelfId": "5XWF",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff508e"
      },
      {
        "shelfId": "U4OH",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff511d"
      },
      {
        "shelfId": "5XUT",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3d3d9bab0f83ff5137"
      }
    ],
    "inventory": {
      "quantity": 54
    }
  },
  {
    "gtin": "01000008",
    "name": "Honey Oats",
    "brandName": "BreakfastBest",
    "baseCategory": "Cereals & Breakfast",
    "reportedPrice": {
      "amount": 3.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745007012/products/pim/8700216707664-189486154/lenor-colorwaschmittel-pods-bluetentraum",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.035,
      "x1": 1.0,
      "y1": 0.96,
      "aspect": 1.0811
    },
    "placements": [
      {
        "shelfId": "KP5H",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3d3d9bab0f83ff5193"
      },
      {
        "shelfId": "CZR6",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff51db"
      }
    ],
    "inventory": {
      "quantity": 1
    }
  },
  {
    "gtin": "01000009",
    "name": "Ice Cream",
    "brandName": "CoolTreats",
    "baseCategory": "Frozen Foods",
    "reportedPrice": {
      "amount": 4.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 5.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745005492/products/pim/4067796084825-256692834/profissimo-ameisenstopp-spray",
    "imageOutline": {
      "x0": 0.275,
      "y0": 0.0,
      "x1": 0.73,
      "y1": 1.0,
      "aspect": 0.455
    },
    "placements": [
      {
        "shelfId": "O99O",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff522f"
      },
      {
        "shelfId": "U85I",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff5262"
      },
      {
        "shelfId": "J55R",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff5291"
      },
      {
        "shelfId": "X8IJ",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff5349"
      }
    ],
    "inventory": {
      "quantity": 45
    }
  },
  {
    "gtin": "01000010",
    "name": "Jelly Beans",
    "brandName": "CandyLand",
    "baseCategory": "Sweets & Confectionery",
    "reportedPrice": {
      "amount": 1.29,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.39,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745001518/products/pim/8720181291890-1814439390/dove-antitranspirant-deospray-advanced-care-summer-care",
    "imageOutline": {
      "x0": 0.385,
      "y0": 0.0,
      "x1": 0.62,
      "y1": 1.0,
      "aspect": 0.235
    },
    "placements": [
      {
        "shelfId": "U0JR",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff53b9"
      },
      {
        "shelfId": "XKQG",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff53ef"
      }
    ],
    "inventory": {
      "quantity": 57
    }
  },
  {
    "gtin": "01000011",
    "name": "Kiwi Jam",
    "brandName": "FruitDelight",
    "baseCategory": "Spreads",
    "reportedPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.39,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745002790/products/pim/42449980-62095101/hidrofugal-antitranspirant-deo-roll-on-classic",
    "imageOutline": {
      "x0": 0.32,
      "y0": 0.0,
      "x1": 0.685,
      "y1": 1.0,
      "aspect": 0.365
    },
    "placements": [
      {
        "shelfId": "DCMY",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5f70"
      }
    ],
    "inventory": {
      "quantity": 0
    }
  },
  {
    "gtin": "01000012",
    "name": "Lemonade",
    "brandName": "CitrusFresh",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 1.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745001512/products/pim/8720689036900-1149228168/philips-sonicare-aufsteckbuersten-w2-optimalwhite-schwarz",
    "imageOutline": {
      "x0": 0.37,
      "y0": 0.0,
      "x1": 0.63,
      "y1": 1.0,
      "aspect": 0.26
    },
    "placements": [
      {
        "shelfId": "E0W2",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff5738"
      }
    ],
    "inventory": {
      "quantity": 42
    }
  },
  {
    "gtin": "01000013",
    "name": "Mango Lassi",
    "brandName": "Yogurto",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 0.89,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1752195176/products/pim/3600542462150-790128866/wahre-schaetze-conditioner-honig-schaetze",
    "imageOutline": {
      "x0": 0.24,
      "y0": 0.0,
      "x1": 0.76,
      "y1": 1.0,
      "aspect": 0.52
    },
    "placements": [
      {
        "shelfId": "HVVZ",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3d3d9bab0f83ff5755"
      }
    ],
    "inventory": {
      "quantity": 0
    }
  },
  {
    "gtin": "01000014",
    "name": "Nutty Bars",
    "brandName": "SnackCo",
    "baseCategory": "Snacks",
    "reportedPrice": {
      "amount": 1.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744963383/products/pim/4260488132495-617726757/nature-love-biotin-komplex-tabletten-90-st",
    "imageOutline": {
      "x0": 0.02,
      "y0": 0.0,
      "x1": 0.98,
      "y1": 1.0,
      "aspect": 0.96
    },
    "placements": [
      {
        "shelfId": "JCBY",
        "stockLevel": "UNKNOWN",
        "facingId": "679afb3d3d9bab0f83ff5790"
      }
    ],
    "inventory": {
      "quantity": 48
    }
  },
  {
    "gtin": "01000015",
    "name": "Olive Oil",
    "brandName": "PurePress",
    "baseCategory": "Oils & Vinegars",
    "reportedPrice": {
      "amount": 3.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 4.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744826422/products/pim/4058172822391-4124447/profissimo-aetherisches-oel-orange",
    "imageOutline": {
      "x0": 0.3,
      "y0": 0.0,
      "x1": 0.7,
      "y1": 1.0,
      "aspect": 0.4
    },
    "placements": [
      {
        "shelfId": "II59",
        "stockLevel": "UNKNOWN",
        "facingId": "679afb3d3d9bab0f83ff580b"
      }
    ],
    "inventory": {
      "quantity": 45
    }
  },
  {
    "gtin": "01000016",
    "name": "Peach Tea",
    "brandName": "TeaTime",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 1.29,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.39,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744991209/products/pim/4066447725278-1919558418/balea-bodycreme-vanille-und-kokos",
    "imageOutline": {
      "x0": 0.055,
      "y0": 0.0,
      "x1": 0.945,
      "y1": 1.0,
      "aspect": 0.89
    },
    "placements": [
      {
        "shelfId": "4N8Z",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3d3d9bab0f83ff5845"
      }
    ],
    "inventory": {
      "quantity": 37
    }
  },
  {
    "gtin": "01000017",
    "name": "Quinoa Salad",
    "brandName": "HealthyChoice",
    "baseCategory": "Salads",
    "reportedPrice": {
      "amount": 4.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 4.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744994755/products/pim/3616301640851-2094238876/bruno-banani-after-shave-man",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.02,
      "x1": 1.0,
      "y1": 0.975,
      "aspect": 1.0471
    },
    "placements": [
      {
        "shelfId": "T80E",
        "stockLevel": "UNKNOWN",
        "facingId": "679afb3d3d9bab0f83ff582e"
      }
    ],
    "inventory": {
      "quantity": 6
    }
  },
  {
    "gtin": "01000018",
    "name": "Raspberry Yogurt",
    "brandName": "DairyDream",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 0.79,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 0.89,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744994218/products/pim/4260524940138-862147343/no-cosmetics-augencreme",
    "imageOutline": {
      "x0": 0.24,
      "y0": 0.0,
      "x1": 0.76,
      "y1": 1.0,
      "aspect": 0.52
    },
    "placements": [
      {
        "shelfId": "PM2N",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff614a"
      }
    ],
    "inventory": {
      "quantity": 24
    }
  },
  {
    "gtin": "01000019",
    "name": "Strawberry Jam",
    "brandName": "BerryBest",
    "baseCategory": "Spreads",
    "reportedPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.39,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744991209/products/pim/4066447725278-1919558418/balea-bodycreme-vanille-und-kokos",
    "imageOutline": {
      "x0": 0.055,
      "y0": 0.0,
      "x1": 0.945,
      "y1": 1.0,
      "aspect": 0.89
    },
    "placements": [
      {
        "shelfId": "OTUP",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3d3d9bab0f83ff585d"
      }
    ],
    "inventory": {
      "quantity": 44
    }
  },
  {
    "gtin": "01000020",
    "name": "Tomato Soup",
    "brandName": "SoupMaster",
    "baseCategory": "Canned & Jarred",
    "reportedPrice": {
      "amount": 1.89,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.09,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744980050/products/pim/4008617138822-1009462392/klosterfrau-arnika-intensiv-creme",
    "imageOutline": {
      "x0": 0.34,
      "y0": 0.0,
      "x1": 0.66,
      "y1": 1.0,
      "aspect": 0.32
    },
    "placements": [
      {
        "shelfId": "L4QV",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff63a1"
      }
    ],
    "inventory": {
      "quantity": 47
    }
  },
  {
    "gtin": "01000021",
    "name": "Udon Noodles",
    "brandName": "NoodleNest",
    "baseCategory": "Pasta & Noodles",
    "reportedPrice": {
      "amount": 1.79,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.89,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1757644508/products/pim/3574661749532-720134251/neutrogena-anti-pickel-gesichtsgel-niacinamide-panthenol",
    "imageOutline": {
      "x0": 0.09,
      "y0": 0.0,
      "x1": 0.91,
      "y1": 1.0,
      "aspect": 0.82
    },
    "placements": [
      {
        "shelfId": "U85I",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3c3d9bab0f83ff5286"
      }
    ],
    "inventory": {
      "quantity": 55
    }
  },
  {
    "gtin": "01000022",
    "name": "Vanilla Pudding",
    "brandName": "SweetTreats",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.09,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744985269/products/pim/4066447782288-1814773585/hallohebamme-babyoel-baeuchlein",
    "imageOutline": {
      "x0": 0.27,
      "y0": 0.0,
      "x1": 0.735,
      "y1": 1.0,
      "aspect": 0.465
    },
    "placements": [
      {
        "shelfId": "JCBY",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3d3d9bab0f83ff57aa"
      }
    ],
    "inventory": {
      "quantity": 45
    }
  },
  {
    "gtin": "01000023",
    "name": "Walnut Brownies",
    "brandName": "NuttyBakes",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 3.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744993995/products/pim/4066447373516-1705774229/balea-augen-make-up-entfernerpads-oelfrei",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.11,
      "x1": 1.0,
      "y1": 0.89,
      "aspect": 1.2821
    },
    "placements": [
      {
        "shelfId": "KJJO",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5ba2"
      }
    ],
    "inventory": {
      "quantity": 11
    }
  },
  {
    "gtin": "01000024",
    "name": "Xylitol Gum",
    "brandName": "FreshChew",
    "baseCategory": "Gum & Mints",
    "reportedPrice": {
      "amount": 0.79,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 0.89,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744999811/products/pim/8700216656054-1857549470/swiffer-bodenwischset-wet-und-dry-kit",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.305,
      "x1": 1.0,
      "y1": 0.695,
      "aspect": 2.5641
    },
    "placements": [
      {
        "shelfId": "YALM",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5945"
      }
    ],
    "inventory": {
      "quantity": 22
    }
  },
  {
    "gtin": "01000025",
    "name": "Yogurt Drink",
    "brandName": "DairyDream",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 0.89,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744991810/products/pim/4063528090744-1077093955/wild-stripes-anti-pickel-patches-smile-prevent",
    "imageOutline": {
      "x0": 0.185,
      "y0": 0.0,
      "x1": 0.815,
      "y1": 1.0,
      "aspect": 0.63
    },
    "placements": [
      {
        "shelfId": "DA90",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5fe4"
      }
    ],
    "inventory": {
      "quantity": 2
    }
  },
  {
    "gtin": "01000026",
    "name": "Zucchini Bread",
    "brandName": "VeggieBake",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 2.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744994900/products/pim/4005900983534-1624596557/nivea-abschminktuecher-3in1-pflegend",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.185,
      "x1": 0.995,
      "y1": 0.815,
      "aspect": 1.5794
    },
    "placements": [
      {
        "shelfId": "U4OH",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3d3d9bab0f83ff5119"
      }
    ],
    "inventory": {
      "quantity": 52
    }
  },
  {
    "gtin": "01000027",
    "name": "Almond Milk",
    "brandName": "NutriMilk",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 1.09,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745005584/products/pim/4104260075603-1781742454/swiss-o-par-augenbrauenfarbe-lichtbraun",
    "imageOutline": {
      "x0": 0.27,
      "y0": 0.0,
      "x1": 0.735,
      "y1": 1.0,
      "aspect": 0.465
    },
    "placements": [
      {
        "shelfId": "CZR6",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff51db"
      }
    ],
    "inventory": {
      "quantity": 12
    }
  },
  {
    "gtin": "01000028",
    "name": "Berry Smoothie",
    "brandName": "SmoothieKing",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 2.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744974077/products/pim/4066447424164-199680776/dmbio-brotaufstrich-vegane-pastete-tomate-olive",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.125,
      "x1": 1.0,
      "y1": 0.87,
      "aspect": 1.3423
    },
    "placements": [
      {
        "shelfId": "MKFF",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6317"
      }
    ],
    "inventory": {
      "quantity": 0
    }
  },
  {
    "gtin": "01000029",
    "name": "Coconut Water",
    "brandName": "TropicalTaste",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 1.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744982706/products/pim/4066447349801-734144307/babylove-babysnack-knusperherzen-apfel-mango-ab-dem-8-monat",
    "imageOutline": {
      "x0": 0.09,
      "y0": 0.0,
      "x1": 0.91,
      "y1": 1.0,
      "aspect": 0.82
    },
    "placements": [
      {
        "shelfId": "J55R",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff529d"
      }
    ],
    "inventory": {
      "quantity": 56
    }
  },
  {
    "gtin": "01000030",
    "name": "Date Bars",
    "brandName": "HealthySnacks",
    "baseCategory": "Snacks",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1757644508/products/pim/3574661749532-720134251/neutrogena-anti-pickel-gesichtsgel-niacinamide-panthenol",
    "imageOutline": {
      "x0": 0.09,
      "y0": 0.0,
      "x1": 0.91,
      "y1": 1.0,
      "aspect": 0.82
    },
    "placements": [
      {
        "shelfId": "K3DS",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff5523"
      }
    ],
    "inventory": {
      "quantity": 22
    }
  },
  {
    "gtin": "01000031",
    "name": "Earl Grey Tea",
    "brandName": "TeaTime",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 1.29,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.39,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745001154/products/pim/4056631000472-1699626600/aptamil-anfangsmilch-pre-ha-von-geburt-an",
    "imageOutline": {
      "x0": 0.19,
      "y0": 0.0,
      "x1": 0.81,
      "y1": 1.0,
      "aspect": 0.62
    },
    "placements": [
      {
        "shelfId": "90YA",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5a6d"
      }
    ],
    "inventory": {
      "quantity": 0
    }
  },
  {
    "gtin": "01000032",
    "name": "Fruit Punch",
    "brandName": "FizzPop",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 1.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1747721796/products/pim/4066447789911-1180389074/denkmit-backofen-und-grillreiniger-mit-aktiv-schaum",
    "imageOutline": {
      "x0": 0.37,
      "y0": 0.0,
      "x1": 0.63,
      "y1": 1.0,
      "aspect": 0.26
    },
    "placements": [
      {
        "shelfId": "4N8Z",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3d3d9bab0f83ff581b"
      }
    ],
    "inventory": {
      "quantity": 2
    }
  },
  {
    "gtin": "01000033",
    "name": "Ginger Ale",
    "brandName": "FizzPop",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.09,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744973144/products/pim/4251758417084-1819924218/sagrotan-allzweckreiniger-mit-desinfektion",
    "imageOutline": {
      "x0": 0.275,
      "y0": 0.0,
      "x1": 0.725,
      "y1": 1.0,
      "aspect": 0.45
    },
    "placements": [
      {
        "shelfId": "TT3H",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5cc1"
      }
    ],
    "inventory": {
      "quantity": 22
    }
  },
  {
    "gtin": "01000034",
    "name": "Hazelnut Spread",
    "brandName": "NuttyBakes",
    "baseCategory": "Spreads",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1749861739/products/pim/4062300470187-1639513820/hipp-baby-pants-gr-6-14-kg",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.09,
      "x1": 1.0,
      "y1": 0.91,
      "aspect": 1.2195
    },
    "placements": [
      {
        "shelfId": "IS38",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3e3d9bab0f83ff6003"
      }
    ],
    "inventory": {
      "quantity": 41
    }
  },
  {
    "gtin": "01000035",
    "name": "Italian Pasta",
    "brandName": "NoodleNest",
    "baseCategory": "Pasta & Noodles",
    "reportedPrice": {
      "amount": 1.79,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.89,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745002006/products/pim/4067796164848-329519398/balea-badesalz-big-dreams",
    "imageOutline": {
      "x0": 0.25,
      "y0": 0.0,
      "x1": 0.75,
      "y1": 1.0,
      "aspect": 0.5
    },
    "placements": [
      {
        "shelfId": "T2D2",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4f2b"
      }
    ],
    "inventory": {
      "quantity": 12
    }
  },
  {
    "gtin": "01000036",
    "name": "Jackfruit Chips",
    "brandName": "SnackCo",
    "baseCategory": "Snacks",
    "reportedPrice": {
      "amount": 1.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744995320/products/pim/4066447771879-585891861/profissimo-besteck-aus-holz",
    "imageOutline": {
      "x0": 0.345,
      "y0": 0.0,
      "x1": 0.66,
      "y1": 1.0,
      "aspect": 0.315
    },
    "placements": [
      {
        "shelfId": "X7I1",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6452"
      }
    ],
    "inventory": {
      "quantity": 47
    }
  },
  {
    "gtin": "01000037",
    "name": "Kale Salad",
    "brandName": "HealthyChoice",
    "baseCategory": "Salads",
    "reportedPrice": {
      "amount": 3.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 4.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745000160/products/pim/4015100812336-1826313115/schwarzkopf-gliss-conditioner-aqua-revive",
    "imageOutline": {
      "x0": 0.295,
      "y0": 0.0,
      "x1": 0.7,
      "y1": 1.0,
      "aspect": 0.405
    },
    "placements": [
      {
        "shelfId": "BH23",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5e1f"
      }
    ],
    "inventory": {
      "quantity": 13
    }
  },
  {
    "gtin": "01000038",
    "name": "Lime Soda",
    "brandName": "FizzPop",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.09,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1747308056/products/pim/80830511-1347805107/borotalco-antitranspirant-deospray-original-reisegroesse",
    "imageOutline": {
      "x0": 0.35,
      "y0": 0.0,
      "x1": 0.645,
      "y1": 1.0,
      "aspect": 0.295
    },
    "placements": [
      {
        "shelfId": "ZRKO",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3f3d9bab0f83ff62fe"
      }
    ],
    "inventory": {
      "quantity": 5
    }
  },
  {
    "gtin": "01000039",
    "name": "Mint Chutney",
    "brandName": "TropicalTaste",
    "baseCategory": "Condiments",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744752005/products/pim/4009077020559-2445577/kinder-em-eukal-bonbon-wildkirsche-fuer-kinder-zuckerfrei",
    "imageOutline": {
      "x0": 0.205,
      "y0": 0.0,
      "x1": 0.795,
      "y1": 1.0,
      "aspect": 0.59
    },
    "placements": [
      {
        "shelfId": "JL9L",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5b9f"
      }
    ],
    "inventory": {
      "quantity": 1
    }
  },
  {
    "gtin": "01000040",
    "name": "Orange Juice",
    "brandName": "FreshFarms",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 1.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744984838/products/pim/4066447600094-924726970/balea-men-antitranspirant-deospray-invisible-dry",
    "imageOutline": {
      "x0": 0.365,
      "y0": 0.0,
      "x1": 0.635,
      "y1": 1.0,
      "aspect": 0.27
    },
    "placements": [
      {
        "shelfId": "OXVF",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3f3d9bab0f83ff62cf"
      }
    ],
    "inventory": {
      "quantity": 7
    }
  },
  {
    "gtin": "01000041",
    "name": "Papaya Jam",
    "brandName": "FruitDelight",
    "baseCategory": "Spreads",
    "reportedPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.39,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744969460/products/pim/4066447580259-859863396/babylove-abendbrei-milchreis-pur-ab-dem-8-monat",
    "imageOutline": {
      "x0": 0.24,
      "y0": 0.0,
      "x1": 0.765,
      "y1": 1.0,
      "aspect": 0.525
    },
    "placements": [
      {
        "shelfId": "SQDY",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5f0d"
      }
    ],
    "inventory": {
      "quantity": 43
    }
  },
  {
    "gtin": "01000042",
    "name": "Quince Jelly",
    "brandName": "BerryBest",
    "baseCategory": "Spreads",
    "reportedPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.39,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745887591/products/pim/4009077024106-2034703920/em-eukal-bonbon-klassisch-zuckerfrei",
    "imageOutline": {
      "x0": 0.155,
      "y0": 0.02,
      "x1": 0.845,
      "y1": 1.0,
      "aspect": 0.7041
    },
    "placements": [
      {
        "shelfId": "3QD4",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5aa9"
      }
    ],
    "inventory": {
      "quantity": 16
    }
  },
  {
    "gtin": "01000043",
    "name": "Raisin Bread",
    "brandName": "VeggieBake",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 3.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744998337/products/pim/42449782-810034511/nivea-antitranspirant-deostick-derma-dry-control-maximum",
    "imageOutline": {
      "x0": 0.28,
      "y0": 0.045,
      "x1": 0.755,
      "y1": 1.0,
      "aspect": 0.4974
    },
    "placements": [
      {
        "shelfId": "0ZLK",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4ef5"
      }
    ],
    "inventory": {
      "quantity": 23
    }
  },
  {
    "gtin": "01000044",
    "name": "Spinach Wrap",
    "brandName": "HealthyChoice",
    "baseCategory": "Wraps & Tortillas",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744817264/products/pim/4030300022033-3813858/wick-bonbon-blau-mit-menthol-zuckerfrei",
    "imageOutline": {
      "x0": 0.165,
      "y0": 0.0,
      "x1": 0.83,
      "y1": 1.0,
      "aspect": 0.665
    },
    "placements": [
      {
        "shelfId": "9AXY",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff54a1"
      }
    ],
    "inventory": {
      "quantity": 34
    }
  },
  {
    "gtin": "01000045",
    "name": "Tapioca Pudding",
    "brandName": "SweetTreats",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.09,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744996021/products/pim/8445291643635-933445807/nestle-beba-anfangsmilch-pre-von-geburt-an",
    "imageOutline": {
      "x0": 0.18,
      "y0": 0.0,
      "x1": 0.825,
      "y1": 1.0,
      "aspect": 0.645
    },
    "placements": [
      {
        "shelfId": "2SU4",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5b3b"
      }
    ],
    "inventory": {
      "quantity": 57
    }
  },
  {
    "gtin": "01000046",
    "name": "Ugli Fruit Juice",
    "brandName": "FreshFarms",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 1.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744994900/products/pim/4005900983534-1624596557/nivea-abschminktuecher-3in1-pflegend",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.185,
      "x1": 0.995,
      "y1": 0.815,
      "aspect": 1.5794
    },
    "placements": [
      {
        "shelfId": "VG4F",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5be8"
      }
    ],
    "inventory": {
      "quantity": 58
    }
  },
  {
    "gtin": "01000047",
    "name": "Vanilla Wafers",
    "brandName": "CookieJar",
    "baseCategory": "Sweets & Confectionery",
    "reportedPrice": {
      "amount": 1.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.59,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744808414/products/pim/4058172737381-3518267/dmbio-brotaufstrich-vegane-pastete-shiitake-champignon",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.115,
      "x1": 1.0,
      "y1": 0.885,
      "aspect": 1.2987
    },
    "placements": [
      {
        "shelfId": "OWNW",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5bf9"
      }
    ],
    "inventory": {
      "quantity": 54
    }
  },
  {
    "gtin": "01000048",
    "name": "Watermelon Soda",
    "brandName": "FizzPop",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.09,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744985435/products/pim/3574661817071-1957785809/penaten-baby-badezusatz-bad-und-shampoo-intensiv",
    "imageOutline": {
      "x0": 0.27,
      "y0": 0.0,
      "x1": 0.735,
      "y1": 1.0,
      "aspect": 0.465
    },
    "placements": [
      {
        "shelfId": "D0WB",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5f32"
      }
    ],
    "inventory": {
      "quantity": 25
    }
  },
  {
    "gtin": "01000049",
    "name": "Xtra Crunch Chips",
    "brandName": "SnackCo",
    "baseCategory": "Snacks",
    "reportedPrice": {
      "amount": 1.79,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.89,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744996486/products/pim/4006000087719-668401390/nivea-anti-falten-augencreme-q10-energy",
    "imageOutline": {
      "x0": 0.345,
      "y0": 0.0,
      "x1": 0.655,
      "y1": 1.0,
      "aspect": 0.31
    },
    "placements": [
      {
        "shelfId": "3FNR",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5ed7"
      }
    ],
    "inventory": {
      "quantity": 37
    }
  },
  {
    "gtin": "01000050",
    "name": "Yam Fries",
    "brandName": "VeggieBake",
    "baseCategory": "Frozen Foods",
    "reportedPrice": {
      "amount": 2.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745000509/products/pim/8710447492239-111425826/rexona-antitranspirant-deospray-active-morning",
    "imageOutline": {
      "x0": 0.37,
      "y0": 0.0,
      "x1": 0.635,
      "y1": 1.0,
      "aspect": 0.265
    },
    "placements": [
      {
        "shelfId": "DCMY",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5ec2"
      }
    ],
    "inventory": {
      "quantity": 59
    }
  },
  {
    "gtin": "01000051",
    "name": "Apple Cider",
    "brandName": "FreshFarms",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 1.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745454104/products/pim/4036581252886-1950112390/zirkulin-biotix-kulturen-komplex-kapseln-28-st",
    "imageOutline": {
      "x0": 0.285,
      "y0": 0.0,
      "x1": 0.71,
      "y1": 1.0,
      "aspect": 0.425
    },
    "placements": [
      {
        "shelfId": "LVPL",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5e8f"
      }
    ],
    "inventory": {
      "quantity": 60
    }
  },
  {
    "gtin": "01000052",
    "name": "Apple Pie",
    "brandName": "SweetTreats",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 3.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745001097/products/pim/7613038463582-83729639/nestle-beba-anfangsmilch-pre-von-geburt-an",
    "imageOutline": {
      "x0": 0.15,
      "y0": 0.0,
      "x1": 0.845,
      "y1": 1.0,
      "aspect": 0.695
    },
    "placements": [
      {
        "shelfId": "IS38",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5efd"
      }
    ],
    "inventory": {
      "quantity": 14
    }
  },
  {
    "gtin": "01000053",
    "name": "Banana Bread",
    "brandName": "CookieJar",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 3.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744968964/products/pim/4051424570019-1495879709/dr-scheller-anti-falten-nachtcreme-argan",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.105,
      "x1": 1.0,
      "y1": 0.89,
      "aspect": 1.2739
    },
    "placements": [
      {
        "shelfId": "SQDY",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5eaf"
      }
    ],
    "inventory": {
      "quantity": 48
    }
  },
  {
    "gtin": "01000054",
    "name": "Banana Smoothie",
    "brandName": "SmoothieKing",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 2.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1750897276/products/pim/42449829-60885883/nivea-care-creme-intensive-pflege-2",
    "imageOutline": {
      "x0": 0.005,
      "y0": 0.095,
      "x1": 1.0,
      "y1": 0.905,
      "aspect": 1.2284
    },
    "placements": [
      {
        "shelfId": "DCMY",
        "stockLevel": "UNKNOWN",
        "facingId": "679afb3e3d9bab0f83ff606e"
      }
    ],
    "inventory": {
      "quantity": 40
    }
  },
  {
    "gtin": "01000055",
    "name": "Carrot Juice",
    "brandName": "FreshFarms",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 1.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744986814/products/pim/4066447107135-405920019/alverde-men-bartserum-rough-nature",
    "imageOutline": {
      "x0": 0.33,
      "y0": 0.0,
      "x1": 0.665,
      "y1": 1.0,
      "aspect": 0.335
    },
    "placements": [
      {
        "shelfId": "AA8H",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3e3d9bab0f83ff61ad"
      }
    ],
    "inventory": {
      "quantity": 41
    }
  },
  {
    "gtin": "01000056",
    "name": "Carrot Muffin",
    "brandName": "SweetTreats",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744986681/products/pim/4066447725230-1988101657/mivolis-bonbon-salbeibonbons-zuckerfrei",
    "imageOutline": {
      "x0": 0.12,
      "y0": 0.0,
      "x1": 0.885,
      "y1": 1.0,
      "aspect": 0.765
    },
    "placements": [
      {
        "shelfId": "A4U7",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff61bc"
      }
    ],
    "inventory": {
      "quantity": 57
    }
  },
  {
    "gtin": "01000057",
    "name": "Dairy Yogurt",
    "brandName": "DairyDream",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 0.79,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 0.89,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744804512/products/pim/4066447105414-3441815/dmbio-backmischung-dinkel-kaiserschmarrn",
    "imageOutline": {
      "x0": 0.175,
      "y0": 0.0,
      "x1": 0.825,
      "y1": 1.0,
      "aspect": 0.65
    },
    "placements": [
      {
        "shelfId": "F9ZL",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff620a"
      }
    ],
    "inventory": {
      "quantity": 48
    }
  },
  {
    "gtin": "9100000161723",
    "name": "Dairy Cheese",
    "brandName": "MilkyWay",
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744817263/products/pim/4030300022088-3813860/wick-bonbon-zitrone-mit-menthol-zuckerfrei",
    "imageOutline": {
      "x0": 0.165,
      "y0": 0.0,
      "x1": 0.83,
      "y1": 1.0,
      "aspect": 0.665
    },
    "placements": [
      {
        "shelfId": "N2DT",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6259"
      }
    ],
    "inventory": {
      "quantity": 23
    }
  },
  {
    "gtin": "01000059",
    "name": "Egg Salad",
    "brandName": "HealthyChoice",
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744983535/products/pim/4008137009312-990918173/bad-heilbrunner-arzneitee-husten-und-bronchial-tee-12-beutel",
    "imageOutline": {
      "x0": 0.135,
      "y0": 0.0,
      "x1": 0.865,
      "y1": 1.0,
      "aspect": 0.73
    },
    "placements": [
      {
        "shelfId": "F01K",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff622a"
      }
    ],
    "inventory": {
      "quantity": 60
    }
  },
  {
    "gtin": "01000060",
    "name": "Egg Tart",
    "brandName": "SweetTreats",
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744980954/products/pim/4066447709889-1906462775/babylove-baby-koerperlotion-ultra-sensitive",
    "imageOutline": {
      "x0": 0.315,
      "y0": 0.0,
      "x1": 0.68,
      "y1": 1.0,
      "aspect": 0.365
    },
    "placements": [
      {
        "shelfId": "OXVF",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3f3d9bab0f83ff62fa"
      }
    ],
    "inventory": {
      "quantity": 46
    }
  },
  {
    "gtin": "01000061",
    "name": "Apple Cider Vinegar",
    "brandName": "FreshFarms",
    "baseCategory": "Condiments",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744974561/products/pim/742042736133-1967471171/shield-n-bettwanzenspray",
    "imageOutline": {
      "x0": 0.3,
      "y0": 0.0,
      "x1": 0.7,
      "y1": 1.0,
      "aspect": 0.4
    },
    "placements": [
      {
        "shelfId": "ZRKO",
        "stockLevel": "UNKNOWN",
        "facingId": "679afb3f3d9bab0f83ff6301"
      }
    ],
    "inventory": {
      "quantity": 59
    }
  },
  {
    "gtin": "01000062",
    "name": "Apple Sauce",
    "brandName": "FreshFarms",
    "baseCategory": "Canned & Jarred",
    "reportedPrice": {
      "amount": 1.79,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.99,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1746791166/products/pim/4066447713480-1543093769/balea-anti-falten-gesichtscreme-q10-lsf-15",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.125,
      "x1": 1.0,
      "y1": 0.875,
      "aspect": 1.3333
    },
    "placements": [
      {
        "shelfId": "MKFF",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6318"
      }
    ],
    "inventory": {
      "quantity": 4
    }
  },
  {
    "gtin": "01000063",
    "name": "Apple Tart",
    "brandName": "SweetTreats",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 3.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 4.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744998713/products/pim/4006000131467-926683978/hidrofugal-antitranspirant-deospray-men-frisch-und-stark",
    "imageOutline": {
      "x0": 0.37,
      "y0": 0.0,
      "x1": 0.635,
      "y1": 1.0,
      "aspect": 0.265
    },
    "placements": [
      {
        "shelfId": "0ZLK",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6325"
      }
    ],
    "inventory": {
      "quantity": 20
    }
  },
  {
    "gtin": "01000064",
    "name": "Apple Chips",
    "brandName": "SnackCo",
    "baseCategory": "Snacks",
    "reportedPrice": {
      "amount": 2.29,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744974160/products/pim/4066447614381-1874903551/mivolis-bonbon-rote-und-gelbe-fruechte-fuer-kinder-zuckerfrei",
    "imageOutline": {
      "x0": 0.15,
      "y0": 0.0,
      "x1": 0.845,
      "y1": 1.0,
      "aspect": 0.695
    },
    "placements": [
      {
        "shelfId": "T2D2",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6332"
      }
    ],
    "inventory": {
      "quantity": 31
    }
  },
  {
    "gtin": "01000065",
    "name": "Apple Jam",
    "brandName": "FruitDelight",
    "baseCategory": "Spreads",
    "reportedPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.39,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745001068/products/pim/4006000121062-103251662/hidrofugal-antitranspirant-deospray-dusch-frische",
    "imageOutline": {
      "x0": 0.24,
      "y0": 0.185,
      "x1": 0.775,
      "y1": 0.8,
      "aspect": 0.8699
    },
    "placements": [
      {
        "shelfId": "L4QV",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3f3d9bab0f83ff633f"
      }
    ],
    "inventory": {
      "quantity": 55
    }
  },
  {
    "gtin": "01000066",
    "name": "Banana Milkshake",
    "brandName": "SmoothieKing",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 2.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745005584/products/pim/4104260075603-1781742454/swiss-o-par-augenbrauenfarbe-lichtbraun",
    "imageOutline": {
      "x0": 0.27,
      "y0": 0.0,
      "x1": 0.735,
      "y1": 1.0,
      "aspect": 0.465
    },
    "placements": [
      {
        "shelfId": "ICHT",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff634c"
      }
    ],
    "inventory": {
      "quantity": 54
    }
  },
  {
    "gtin": "01000067",
    "name": "Banana Pudding",
    "brandName": "SweetTreats",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 1.29,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.39,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744807960/products/pim/3600524062651-3499308/l-oreal-paris-men-expert-bartshampoo-barber-club-3in1",
    "imageOutline": {
      "x0": 0.315,
      "y0": 0.0,
      "x1": 0.685,
      "y1": 1.0,
      "aspect": 0.37
    },
    "placements": [
      {
        "shelfId": "IXEY",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6359"
      }
    ],
    "inventory": {
      "quantity": 58
    }
  },
  {
    "gtin": "01000068",
    "name": "Banana Muffin",
    "brandName": "CookieJar",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1747307598/products/pim/9005800379227-982780705/nivea-men-antitranspirant-deospray-alpine-breeze",
    "imageOutline": {
      "x0": 0.365,
      "y0": 0.0,
      "x1": 0.63,
      "y1": 1.0,
      "aspect": 0.265
    },
    "placements": [
      {
        "shelfId": "0APM",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6366"
      }
    ],
    "inventory": {
      "quantity": 16
    }
  },
  {
    "gtin": "01000069",
    "name": "Banana Yogurt",
    "brandName": "DairyDream",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 0.89,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745001068/products/pim/4006000121062-103251662/hidrofugal-antitranspirant-deospray-dusch-frische",
    "imageOutline": {
      "x0": 0.24,
      "y0": 0.185,
      "x1": 0.775,
      "y1": 0.8,
      "aspect": 0.8699
    },
    "placements": [
      {
        "shelfId": "X7I1",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6373"
      }
    ],
    "inventory": {
      "quantity": 46
    }
  },
  {
    "gtin": "01000070",
    "name": "Carrot Soup",
    "brandName": "SoupMaster",
    "baseCategory": "Canned & Jarred",
    "reportedPrice": {
      "amount": 1.89,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.09,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744997730/products/pim/4066447438413-2131253223/balea-2in1-fussschutz-und-deo-spray",
    "imageOutline": {
      "x0": 0.375,
      "y0": 0.0,
      "x1": 0.63,
      "y1": 1.0,
      "aspect": 0.255
    },
    "placements": [
      {
        "shelfId": "WAX7",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6380"
      }
    ],
    "inventory": {
      "quantity": 41
    }
  },
  {
    "gtin": "01000071",
    "name": "Carrot Chips",
    "brandName": "HealthySnacks",
    "baseCategory": "Snacks",
    "reportedPrice": {
      "amount": 2.29,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745001502/products/pim/8700216595841-774432430/pampers-baby-pants-baby-dry-gr-4-maxi-9-15-kg-big-pack",
    "imageOutline": {
      "x0": 0.255,
      "y0": 0.0,
      "x1": 0.75,
      "y1": 1.0,
      "aspect": 0.495
    },
    "placements": [
      {
        "shelfId": "9BAH",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff638d"
      }
    ],
    "inventory": {
      "quantity": 50
    }
  },
  {
    "gtin": "01000072",
    "name": "Carrot Bread",
    "brandName": "VeggieBake",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 3.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1748304678/products/pim/4067796203639-2146359630/dmbio-brotaufstrich-getrocknete-tomate-und-feta",
    "imageOutline": {
      "x0": 0.085,
      "y0": 0.0,
      "x1": 0.915,
      "y1": 1.0,
      "aspect": 0.83
    },
    "placements": [
      {
        "shelfId": "KR6V",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff639a"
      }
    ],
    "inventory": {
      "quantity": 59
    }
  },
  {
    "gtin": "01000073",
    "name": "Dairy Cream",
    "brandName": "MilkyWay",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 1.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1746847637/products/pim/4015637827438-1620612822/bauck-muehle-backmischung-muehlenbrot-7-saaten-glutenfrei",
    "imageOutline": {
      "x0": 0.315,
      "y0": 0.0,
      "x1": 0.685,
      "y1": 1.0,
      "aspect": 0.37
    },
    "placements": [
      {
        "shelfId": "KNRE",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff63a7"
      }
    ],
    "inventory": {
      "quantity": 41
    }
  },
  {
    "gtin": "01000074",
    "name": "Dairy Ice Cream",
    "brandName": "CoolTreats",
    "baseCategory": "Frozen Foods",
    "reportedPrice": {
      "amount": 4.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 5.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745000752/products/pim/8720181291920-540327272/dove-antitranspirant-deospray-advanced-care-original",
    "imageOutline": {
      "x0": 0.385,
      "y0": 0.0,
      "x1": 0.62,
      "y1": 1.0,
      "aspect": 0.235
    },
    "placements": [
      {
        "shelfId": "RV6G",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff63b4"
      }
    ],
    "inventory": {
      "quantity": 50
    }
  },
  {
    "gtin": "01000075",
    "name": "Dairy Butter",
    "brandName": "MilkyWay",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 2.29,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744820823/products/pim/5903719642385-3835202/la-rive-absolute-sport-eau-de-toilette",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.03,
      "x1": 1.0,
      "y1": 0.965,
      "aspect": 1.0695
    },
    "placements": [
      {
        "shelfId": "PED2",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff63c1"
      }
    ],
    "inventory": {
      "quantity": 46
    }
  },
  {
    "gtin": "01000076",
    "name": "Egg Sandwich",
    "brandName": "HealthyChoice",
    "baseCategory": "Sandwiches",
    "reportedPrice": {
      "amount": 3.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744981053/products/pim/4008871200945-1507941193/toppits-alufolie-extra-reissfest",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.405,
      "x1": 1.0,
      "y1": 0.595,
      "aspect": 5.2632
    },
    "placements": [
      {
        "shelfId": "8CS4",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff63ce"
      }
    ],
    "inventory": {
      "quantity": 46
    }
  },
  {
    "gtin": "01000077",
    "name": "Egg Fried Rice",
    "brandName": "NoodleNest",
    "baseCategory": "Frozen Foods",
    "reportedPrice": {
      "amount": 2.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744804512/products/pim/4066447105414-3441815/dmbio-backmischung-dinkel-kaiserschmarrn",
    "imageOutline": {
      "x0": 0.175,
      "y0": 0.0,
      "x1": 0.825,
      "y1": 1.0,
      "aspect": 0.65
    },
    "placements": [
      {
        "shelfId": "2XNU",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff63db"
      }
    ],
    "inventory": {
      "quantity": 10
    }
  },
  {
    "gtin": "01000078",
    "name": "Egg Pasta",
    "brandName": "NoodleNest",
    "baseCategory": "Pasta & Noodles",
    "reportedPrice": {
      "amount": 1.89,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.09,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744980898/products/pim/4066447710083-413034/babylove-baby-kopf-bis-fuss-waschgel-nachfuellpack",
    "imageOutline": {
      "x0": 0.215,
      "y0": 0.005,
      "x1": 0.79,
      "y1": 1.0,
      "aspect": 0.5779
    },
    "placements": [
      {
        "shelfId": "8MXE",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff63e8"
      }
    ],
    "inventory": {
      "quantity": 9
    }
  },
  {
    "gtin": "01000079",
    "name": "Chocolate Chip Cookies",
    "brandName": "CookieJar",
    "baseCategory": "Sweets & Confectionery",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744998172/products/pim/4066447668698-902956023/babylove-baby-pants-premium-gr-6-xl-18-30-kg-jumbo-pack",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.04,
      "x1": 1.0,
      "y1": 0.96,
      "aspect": 1.087
    },
    "placements": [
      {
        "shelfId": "X08Z",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff63f5"
      }
    ],
    "inventory": {
      "quantity": 7
    }
  },
  {
    "gtin": "01000080",
    "name": "Chocolate Milk",
    "brandName": "MilkyWay",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 1.29,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.39,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744980566/products/pim/4066447465419-376616469/alverde-men-active-nature-q10-anti-falten-creme",
    "imageOutline": {
      "x0": 0.255,
      "y0": 0.0,
      "x1": 0.75,
      "y1": 1.0,
      "aspect": 0.495
    },
    "placements": [
      {
        "shelfId": "K35A",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6402"
      }
    ],
    "inventory": {
      "quantity": 60
    }
  },
  {
    "gtin": "01000081",
    "name": "Chocolate Cake",
    "brandName": "SweetTreats",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 4.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 4.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744994541/products/pim/4260133234802-1200395499/fruchtbar-pausenfreund-brotaufstrich-kakao-creme-cashew-und-dattel-ab-3-jahren",
    "imageOutline": {
      "x0": 0.145,
      "y0": 0.0,
      "x1": 0.86,
      "y1": 1.0,
      "aspect": 0.715
    },
    "placements": [
      {
        "shelfId": "PZXD",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff640f"
      }
    ],
    "inventory": {
      "quantity": 3
    }
  },
  {
    "gtin": "01000082",
    "name": "Chocolate Bar",
    "brandName": "CandyLand",
    "baseCategory": "Sweets & Confectionery",
    "reportedPrice": {
      "amount": 1.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1747307578/products/pim/4056631003961-1987340926/milupa-anfangsmilch-pre-milumil-von-geburt-an",
    "imageOutline": {
      "x0": 0.155,
      "y0": 0.0,
      "x1": 0.84,
      "y1": 1.0,
      "aspect": 0.685
    },
    "placements": [
      {
        "shelfId": "2R5C",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff641c"
      }
    ],
    "inventory": {
      "quantity": 16
    }
  },
  {
    "gtin": "01000083",
    "name": "Chocolate Ice Cream",
    "brandName": "CoolTreats",
    "baseCategory": "Frozen Foods",
    "reportedPrice": {
      "amount": 4.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 5.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1756861507/products/pim/4062300414310-1879218932/hipp-anfangsmilch-pre-von-geburt-an",
    "imageOutline": {
      "x0": 0.19,
      "y0": 0.0,
      "x1": 0.81,
      "y1": 1.0,
      "aspect": 0.62
    },
    "placements": [
      {
        "shelfId": "X7BX",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6429"
      }
    ],
    "inventory": {
      "quantity": 36
    }
  },
  {
    "gtin": "01000084",
    "name": "Strawberry Smoothie",
    "brandName": "SmoothieKing",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 2.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745005305/products/pim/4015200035260-684955883/persil-colorwaschmittel-discs",
    "imageOutline": {
      "x0": 0.045,
      "y0": 0.0,
      "x1": 0.96,
      "y1": 1.0,
      "aspect": 0.915
    },
    "placements": [
      {
        "shelfId": "83ZI",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6436"
      }
    ],
    "inventory": {
      "quantity": 2
    }
  },
  {
    "gtin": "01000085",
    "name": "Strawberry Cake",
    "brandName": "SweetTreats",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 4.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 4.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1749210031/products/pim/4066447592085-1395605393/alverde-naturkosmetik-conditioner-glanz-rosenbluetenwasser-und-pflanzlichem-protein",
    "imageOutline": {
      "x0": 0.295,
      "y0": 0.0,
      "x1": 0.705,
      "y1": 1.0,
      "aspect": 0.41
    },
    "placements": [
      {
        "shelfId": "MUZ4",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6443"
      }
    ],
    "inventory": {
      "quantity": 24
    }
  },
  {
    "gtin": "01000086",
    "name": "Strawberry Yogurt",
    "brandName": "DairyDream",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 0.89,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1748996729/products/pim/4013182023831-1776916400/nabio-brotaufstrich-paprika-feta-olive",
    "imageOutline": {
      "x0": 0.075,
      "y0": 0.0,
      "x1": 0.92,
      "y1": 1.0,
      "aspect": 0.845
    },
    "placements": [
      {
        "shelfId": "OFVB",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6450"
      }
    ],
    "inventory": {
      "quantity": 19
    }
  },
  {
    "gtin": "01000087",
    "name": "Strawberry Ice Cream",
    "brandName": "CoolTreats",
    "baseCategory": "Frozen Foods",
    "reportedPrice": {
      "amount": 4.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 5.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745002971/products/pim/8700216624688-1338136508/meister-proper-allzweckreiniger-fruehlingserwachen",
    "imageOutline": {
      "x0": 0.27,
      "y0": 0.0,
      "x1": 0.725,
      "y1": 1.0,
      "aspect": 0.455
    },
    "placements": [
      {
        "shelfId": "ACMA",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff645d"
      }
    ],
    "inventory": {
      "quantity": 42
    }
  },
  {
    "gtin": "01000088",
    "name": "Organic Apple Juice",
    "brandName": "FreshFarms",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744986312/products/pim/4045607001018-1788720220/haka-allzweckreiniger-eco-allesreiniger",
    "imageOutline": {
      "x0": 0.325,
      "y0": 0.0,
      "x1": 0.675,
      "y1": 1.0,
      "aspect": 0.35
    },
    "placements": [
      {
        "shelfId": "O9AI",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff646a"
      }
    ],
    "inventory": {
      "quantity": 45
    }
  },
  {
    "gtin": "01000089",
    "name": "Green Apple Soda",
    "brandName": "FizzPop",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.09,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744983600/products/pim/4006000083698-577427607/nivea-bodylotion-repair-und-care",
    "imageOutline": {
      "x0": 0.325,
      "y0": 0.0,
      "x1": 0.675,
      "y1": 1.0,
      "aspect": 0.35
    },
    "placements": [
      {
        "shelfId": "12YG",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6477"
      }
    ],
    "inventory": {
      "quantity": 53
    }
  },
  {
    "gtin": "01000090",
    "name": "Red Apple Chips",
    "brandName": "HealthySnacks",
    "baseCategory": "Snacks",
    "reportedPrice": {
      "amount": 2.29,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744986681/products/pim/4066447725230-1988101657/mivolis-bonbon-salbeibonbons-zuckerfrei",
    "imageOutline": {
      "x0": 0.12,
      "y0": 0.0,
      "x1": 0.885,
      "y1": 1.0,
      "aspect": 0.765
    },
    "placements": [
      {
        "shelfId": "8FV1",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6484"
      }
    ],
    "inventory": {
      "quantity": 7
    }
  },
  {
    "gtin": "01000091",
    "name": "Vanilla Ice Cream",
    "brandName": "CoolTreats",
    "baseCategory": "Frozen Foods",
    "reportedPrice": {
      "amount": 4.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 5.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1755130029/products/pim/4011448001104-761711982/kaufm-creme-baby-und-kinder-pflegecreme",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.005,
      "x1": 1.0,
      "y1": 1.0,
      "aspect": 1.005
    },
    "placements": [
      {
        "shelfId": "USE9",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6491"
      }
    ],
    "inventory": {
      "quantity": 56
    }
  },
  {
    "gtin": "01000092",
    "name": "Vanilla Cake",
    "brandName": "SweetTreats",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 4.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 4.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744974561/products/pim/742042736133-1967471171/shield-n-bettwanzenspray",
    "imageOutline": {
      "x0": 0.3,
      "y0": 0.0,
      "x1": 0.7,
      "y1": 1.0,
      "aspect": 0.4
    },
    "placements": [
      {
        "shelfId": "CCLK",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff649e"
      }
    ],
    "inventory": {
      "quantity": 43
    }
  },
  {
    "gtin": "01000093",
    "name": "Vanilla Yogurt",
    "brandName": "DairyDream",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 0.89,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745002435/products/pim/5011321772335-1402007474/old-spice-after-shave-original",
    "imageOutline": {
      "x0": 0.29,
      "y0": 0.0,
      "x1": 0.71,
      "y1": 1.0,
      "aspect": 0.42
    },
    "placements": [
      {
        "shelfId": "FZPF",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff64ab"
      }
    ],
    "inventory": {
      "quantity": 26
    }
  },
  {
    "gtin": "01000094",
    "name": "Vanilla Cookies",
    "brandName": "CookieJar",
    "baseCategory": "Sweets & Confectionery",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1747705041/products/pim/4062300419407-1031445645/hipp-babysanft-baby-waschgel-haut-und-haar-sensitiv-nachfuellpack",
    "imageOutline": {
      "x0": 0.17,
      "y0": 0.0,
      "x1": 0.835,
      "y1": 1.0,
      "aspect": 0.665
    },
    "placements": [
      {
        "shelfId": "YY8P",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff64b8"
      }
    ],
    "inventory": {
      "quantity": 28
    }
  },
  {
    "gtin": "01000095",
    "name": "Mixed Berry Juice",
    "brandName": "FreshFarms",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 2.29,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1757203663/products/pim/4062300419445-2080079871/hipp-babysanft-baby-pflegeoel-sensitiv",
    "imageOutline": {
      "x0": 0.285,
      "y0": 0.0,
      "x1": 0.715,
      "y1": 1.0,
      "aspect": 0.43
    },
    "placements": [
      {
        "shelfId": "7VS8",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff64c5"
      }
    ],
    "inventory": {
      "quantity": 26
    }
  },
  {
    "gtin": "01000096",
    "name": "Berry Muffin",
    "brandName": "CookieJar",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744794200/products/pim/4260702181933-3010525/jean-und-len-conditioner-repair-dattel-und-vanille",
    "imageOutline": {
      "x0": 0.39,
      "y0": 0.0,
      "x1": 0.61,
      "y1": 1.0,
      "aspect": 0.22
    },
    "placements": [
      {
        "shelfId": "GI4V",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff64d2"
      }
    ],
    "inventory": {
      "quantity": 59
    }
  },
  {
    "gtin": "01000097",
    "name": "Berry Yogurt",
    "brandName": "DairyDream",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 0.89,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744963383/products/pim/4260488132495-617726757/nature-love-biotin-komplex-tabletten-90-st",
    "imageOutline": {
      "x0": 0.02,
      "y0": 0.0,
      "x1": 0.98,
      "y1": 1.0,
      "aspect": 0.96
    },
    "placements": [
      {
        "shelfId": "T6G8",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff64df"
      }
    ],
    "inventory": {
      "quantity": 36
    }
  },
  {
    "gtin": "01000098",
    "name": "Berry Pie",
    "brandName": "SweetTreats",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 4.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 4.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744794200/products/pim/4260702181933-3010525/jean-und-len-conditioner-repair-dattel-und-vanille",
    "imageOutline": {
      "x0": 0.39,
      "y0": 0.0,
      "x1": 0.61,
      "y1": 1.0,
      "aspect": 0.22
    },
    "placements": [
      {
        "shelfId": "JGU7",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff64ec"
      }
    ],
    "inventory": {
      "quantity": 16
    }
  },
  {
    "gtin": "01000099",
    "name": "Milk Chocolate",
    "brandName": "CandyLand",
    "baseCategory": "Sweets & Confectionery",
    "reportedPrice": {
      "amount": 1.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744751902/products/pim/4058172716232-2429827/dmbio-basmatireis-aus-vollkorn",
    "imageOutline": {
      "x0": 0.185,
      "y0": 0.0,
      "x1": 0.81,
      "y1": 1.0,
      "aspect": 0.625
    },
    "placements": [
      {
        "shelfId": "H9YO",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff64f9"
      }
    ],
    "inventory": {
      "quantity": 24
    }
  },
  {
    "gtin": "01000100",
    "name": "Milk Powder",
    "brandName": "MilkyWay",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 3.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1746616929/products/pim/4067796154221-2030421819/balea-professional-conditioner-glossy-color",
    "imageOutline": {
      "x0": 0.265,
      "y0": 0.0,
      "x1": 0.74,
      "y1": 1.0,
      "aspect": 0.475
    },
    "placements": [
      {
        "shelfId": "U0ES",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6506"
      }
    ],
    "inventory": {
      "quantity": 26
    }
  },
  {
    "gtin": "01000101",
    "name": "Coconut Milk",
    "brandName": "TropicalTaste",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 1.79,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.99,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744997310/products/pim/4009932008999-346674500/doppelherz-coenzym-q-10-b-vitamine-kapseln-30-st",
    "imageOutline": {
      "x0": 0.165,
      "y0": 0.0,
      "x1": 0.83,
      "y1": 1.0,
      "aspect": 0.665
    },
    "placements": [
      {
        "shelfId": "VBK4",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6513"
      }
    ],
    "inventory": {
      "quantity": 28
    }
  },
  {
    "gtin": "01000102",
    "name": "Coconut Cookies",
    "brandName": "CookieJar",
    "baseCategory": "Sweets & Confectionery",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1747307938/products/pim/3574661651675-1292649377/neutrogena-anti-age-augencreme-retinol-boost",
    "imageOutline": {
      "x0": 0.13,
      "y0": 0.0,
      "x1": 0.865,
      "y1": 1.0,
      "aspect": 0.735
    },
    "placements": [
      {
        "shelfId": "DEZN",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6520"
      }
    ],
    "inventory": {
      "quantity": 52
    }
  },
  {
    "gtin": "01000103",
    "name": "Coconut Cake",
    "brandName": "SweetTreats",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 4.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 4.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744985269/products/pim/4066447782288-1814773585/hallohebamme-babyoel-baeuchlein",
    "imageOutline": {
      "x0": 0.27,
      "y0": 0.0,
      "x1": 0.735,
      "y1": 1.0,
      "aspect": 0.465
    },
    "placements": [
      {
        "shelfId": "3WYZ",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff652d"
      }
    ],
    "inventory": {
      "quantity": 47
    }
  },
  {
    "gtin": "01000104",
    "name": "Coconut Ice Cream",
    "brandName": "CoolTreats",
    "baseCategory": "Frozen Foods",
    "reportedPrice": {
      "amount": 4.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 5.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1746611368/products/pim/4066447321333-1033478810/balea-augencreme-vital-straffend",
    "imageOutline": {
      "x0": 0.135,
      "y0": 0.0,
      "x1": 0.865,
      "y1": 1.0,
      "aspect": 0.73
    },
    "placements": [
      {
        "shelfId": "SCAP",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff653a"
      }
    ],
    "inventory": {
      "quantity": 51
    }
  },
  {
    "gtin": "01000105",
    "name": "Lemon Juice",
    "brandName": "FreshFarms",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 1.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744983705/products/pim/4006000083353-699695394/nivea-bodylotion-express-normale-haut",
    "imageOutline": {
      "x0": 0.325,
      "y0": 0.0,
      "x1": 0.675,
      "y1": 1.0,
      "aspect": 0.35
    },
    "placements": [
      {
        "shelfId": "IFRD",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6547"
      }
    ],
    "inventory": {
      "quantity": 51
    }
  },
  {
    "gtin": "01000106",
    "name": "Lemon Cake",
    "brandName": "SweetTreats",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 4.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 4.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744985152/products/pim/4021457660322-14537606/lavera-naturkosmetik-bodylotion-barrier-balance",
    "imageOutline": {
      "x0": 0.295,
      "y0": 0.0,
      "x1": 0.705,
      "y1": 1.0,
      "aspect": 0.41
    },
    "placements": [
      {
        "shelfId": "UJGZ",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6554"
      }
    ],
    "inventory": {
      "quantity": 4
    }
  },
  {
    "gtin": "01000107",
    "name": "Lemon Cookies",
    "brandName": "CookieJar",
    "baseCategory": "Sweets & Confectionery",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745002006/products/pim/4067796164848-329519398/balea-badesalz-big-dreams",
    "imageOutline": {
      "x0": 0.25,
      "y0": 0.0,
      "x1": 0.75,
      "y1": 1.0,
      "aspect": 0.5
    },
    "placements": [
      {
        "shelfId": "QC7U",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6561"
      }
    ],
    "inventory": {
      "quantity": 46
    }
  },
  {
    "gtin": "01000108",
    "name": "Orange Cake",
    "brandName": "SweetTreats",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 4.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 4.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1746174627/products/pim/4056631003541-1730136713/aptamil-anfangsmilch-pre-care-von-geburt-an",
    "imageOutline": {
      "x0": 0.19,
      "y0": 0.0,
      "x1": 0.81,
      "y1": 1.0,
      "aspect": 0.62
    },
    "placements": [
      {
        "shelfId": "U0DC",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff656e"
      }
    ],
    "inventory": {
      "quantity": 28
    }
  },
  {
    "gtin": "01000109",
    "name": "Orange Cookies",
    "brandName": "CookieJar",
    "baseCategory": "Sweets & Confectionery",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1747307598/products/pim/9005800379227-982780705/nivea-men-antitranspirant-deospray-alpine-breeze",
    "imageOutline": {
      "x0": 0.365,
      "y0": 0.0,
      "x1": 0.63,
      "y1": 1.0,
      "aspect": 0.265
    },
    "placements": [
      {
        "shelfId": "4LJV",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff657b"
      }
    ],
    "inventory": {
      "quantity": 25
    }
  },
  {
    "gtin": "01000110",
    "name": "Orange Yogurt",
    "brandName": "DairyDream",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 0.89,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744825993/products/pim/4066447248869-4073115/mivolis-biotin-5-mg-n-tabletten",
    "imageOutline": {
      "x0": 0.125,
      "y0": 0.0,
      "x1": 0.87,
      "y1": 1.0,
      "aspect": 0.745
    },
    "placements": [
      {
        "shelfId": "7YSF",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6588"
      }
    ],
    "inventory": {
      "quantity": 5
    }
  },
  {
    "gtin": "01000111",
    "name": "Orange Soda",
    "brandName": "FizzPop",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.09,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744985137/products/pim/4059729438683-28835968/inao-cleanser-exfoliation-feel-pure",
    "imageOutline": {
      "x0": 0.34,
      "y0": 0.0,
      "x1": 0.66,
      "y1": 1.0,
      "aspect": 0.32
    },
    "placements": [
      {
        "shelfId": "8SMF",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6595"
      }
    ],
    "inventory": {
      "quantity": 42
    }
  },
  {
    "gtin": "01000112",
    "name": "Fruit Salad",
    "brandName": "HealthyChoice",
    "baseCategory": "Salads",
    "reportedPrice": {
      "amount": 3.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 4.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744991950/products/pim/4015637007250-454548698/bauck-muehle-backmischung-haferbrot-vollkorn-glutenfrei",
    "imageOutline": {
      "x0": 0.315,
      "y0": 0.0,
      "x1": 0.685,
      "y1": 1.0,
      "aspect": 0.37
    },
    "placements": [
      {
        "shelfId": "ZQ0I",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff65a2"
      }
    ],
    "inventory": {
      "quantity": 14
    }
  },
  {
    "gtin": "01000113",
    "name": "Fruit Cake",
    "brandName": "SweetTreats",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 4.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 4.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744752005/products/pim/4009077020559-2445577/kinder-em-eukal-bonbon-wildkirsche-fuer-kinder-zuckerfrei",
    "imageOutline": {
      "x0": 0.205,
      "y0": 0.0,
      "x1": 0.795,
      "y1": 1.0,
      "aspect": 0.59
    },
    "placements": [
      {
        "shelfId": "5XWF",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff65af"
      }
    ],
    "inventory": {
      "quantity": 9
    }
  },
  {
    "gtin": "01000114",
    "name": "Fruit Smoothie",
    "brandName": "SmoothieKing",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 2.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1746707708/products/pim/4066447750645-1928711266/balea-men-antitranspirant-deo-roll-on-extra-dry",
    "imageOutline": {
      "x0": 0.315,
      "y0": 0.0,
      "x1": 0.69,
      "y1": 1.0,
      "aspect": 0.375
    },
    "placements": [
      {
        "shelfId": "U4OH",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff65bc"
      }
    ],
    "inventory": {
      "quantity": 34
    }
  },
  {
    "gtin": "01000115",
    "name": "Fruit Yogurt",
    "brandName": "DairyDream",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 0.89,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744728374/products/pim/4104260075450-2240313/swiss-o-par-augenbrauen-und-wimpernfarbe-schwarz",
    "imageOutline": {
      "x0": 0.245,
      "y0": 0.0,
      "x1": 0.76,
      "y1": 1.0,
      "aspect": 0.515
    },
    "placements": [
      {
        "shelfId": "5XUT",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff65c9"
      }
    ],
    "inventory": {
      "quantity": 54
    }
  },
  {
    "gtin": "01000116",
    "name": "Tropical Fruit Juice",
    "brandName": "TropicalTaste",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 2.29,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744821290/products/pim/4058172516085-3941388/paradies-bilderrahmen-basic-10x15cm-weiss",
    "imageOutline": {
      "x0": 0.145,
      "y0": 0.0,
      "x1": 0.855,
      "y1": 1.0,
      "aspect": 0.71
    },
    "placements": [
      {
        "shelfId": "KP5H",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff65d6"
      }
    ],
    "inventory": {
      "quantity": 28
    }
  },
  {
    "gtin": "01000117",
    "name": "Chocolate Smoothie",
    "brandName": "SmoothieKing",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 2.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744995998/products/pim/4260401410778-89679819/paediprotect-baby-und-kinder-badezusatz-pflegebad",
    "imageOutline": {
      "x0": 0.305,
      "y0": 0.0,
      "x1": 0.7,
      "y1": 1.0,
      "aspect": 0.395
    },
    "placements": [
      {
        "shelfId": "CZR6",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff65e3"
      }
    ],
    "inventory": {
      "quantity": 39
    }
  },
  {
    "gtin": "01000118",
    "name": "Chocolate Muffin",
    "brandName": "CookieJar",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744998302/products/pim/8700216670647-1739650939/pampers-baby-pants-baby-dry-gr-7-xl-15-kg",
    "imageOutline": {
      "x0": 0.135,
      "y0": 0.0,
      "x1": 0.86,
      "y1": 1.0,
      "aspect": 0.725
    },
    "placements": [
      {
        "shelfId": "O99O",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff65f0"
      }
    ],
    "inventory": {
      "quantity": 27
    }
  },
  {
    "gtin": "01000119",
    "name": "Chocolate Pudding",
    "brandName": "SweetTreats",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 1.29,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.39,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745000414/products/pim/3600542415095-1923903499/garnier-skin-active-bb-creme-all-in-1-pflege-matt-hell-lsf-25",
    "imageOutline": {
      "x0": 0.245,
      "y0": 0.0,
      "x1": 0.75,
      "y1": 1.0,
      "aspect": 0.505
    },
    "placements": [
      {
        "shelfId": "U85I",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff65fd"
      }
    ],
    "inventory": {
      "quantity": 40
    }
  },
  {
    "gtin": "01000120",
    "name": "Chocolate Yogurt",
    "brandName": "DairyDream",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 0.89,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744996272/products/pim/4008137002207-79549604/bad-heilbrunner-arzneitee-schlaf-und-nerven-tee-8-beutel",
    "imageOutline": {
      "x0": 0.17,
      "y0": 0.0,
      "x1": 0.83,
      "y1": 1.0,
      "aspect": 0.66
    },
    "placements": [
      {
        "shelfId": "J55R",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff660a"
      }
    ],
    "inventory": {
      "quantity": 9
    }
  },
  {
    "gtin": "01000121",
    "name": "Pineapple Juice",
    "brandName": "TropicalTaste",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 2.29,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744999217/products/pim/4066447668650-1637626317/babylove-baby-pants-premium-gr-7-xxl-18-kg",
    "imageOutline": {
      "x0": 0.155,
      "y0": 0.0,
      "x1": 0.84,
      "y1": 1.0,
      "aspect": 0.685
    },
    "placements": [
      {
        "shelfId": "X8IJ",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6617"
      }
    ],
    "inventory": {
      "quantity": 20
    }
  },
  {
    "gtin": "01000122",
    "name": "Pineapple Cake",
    "brandName": "SweetTreats",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 4.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 4.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744998337/products/pim/42449782-810034511/nivea-antitranspirant-deostick-derma-dry-control-maximum",
    "imageOutline": {
      "x0": 0.28,
      "y0": 0.045,
      "x1": 0.755,
      "y1": 1.0,
      "aspect": 0.4974
    },
    "placements": [
      {
        "shelfId": "U0JR",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6624"
      }
    ],
    "inventory": {
      "quantity": 33
    }
  },
  {
    "gtin": "01000123",
    "name": "Pineapple Rings",
    "brandName": "TropicalTaste",
    "baseCategory": "Canned & Jarred",
    "reportedPrice": {
      "amount": 1.89,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.09,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745887591/products/pim/4009077024106-2034703920/em-eukal-bonbon-klassisch-zuckerfrei",
    "imageOutline": {
      "x0": 0.155,
      "y0": 0.02,
      "x1": 0.845,
      "y1": 1.0,
      "aspect": 0.7041
    },
    "placements": [
      {
        "shelfId": "XKQG",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6631"
      }
    ],
    "inventory": {
      "quantity": 38
    }
  },
  {
    "gtin": "01000124",
    "name": "Pineapple Pizza",
    "brandName": "ItalianEats",
    "baseCategory": "Frozen Foods",
    "reportedPrice": {
      "amount": 5.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 6.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745000160/products/pim/4015100812336-1826313115/schwarzkopf-gliss-conditioner-aqua-revive",
    "imageOutline": {
      "x0": 0.295,
      "y0": 0.0,
      "x1": 0.7,
      "y1": 1.0,
      "aspect": 0.405
    },
    "placements": [
      {
        "shelfId": "ASLY",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff663e"
      }
    ],
    "inventory": {
      "quantity": 59
    }
  },
  {
    "gtin": "01000125",
    "name": "Snapper Fish",
    "brandName": "SeaFresh",
    "baseCategory": "Seafood",
    "reportedPrice": {
      "amount": 8.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 9.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744982120/products/pim/4066447692914-156492546/profissimo-allzwecktuecher-maxi",
    "imageOutline": {
      "x0": 0.2,
      "y0": 0.0,
      "x1": 0.8,
      "y1": 1.0,
      "aspect": 0.6
    },
    "placements": [
      {
        "shelfId": "V5ZY",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff664b"
      }
    ],
    "inventory": {
      "quantity": 30
    }
  },
  {
    "gtin": "01000126",
    "name": "Cappuccino Mix",
    "brandName": "CoffeeLovers",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 3.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744706128/products/pim/4054411260627-1312167/wiedenbauer-bonbon-mango-orange-gefuellt",
    "imageOutline": {
      "x0": 0.065,
      "y0": 0.0,
      "x1": 0.935,
      "y1": 1.0,
      "aspect": 0.87
    },
    "placements": [
      {
        "shelfId": "6SBB",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6658"
      }
    ],
    "inventory": {
      "quantity": 58
    }
  },
  {
    "gtin": "01000127",
    "name": "Cappuccino Cookies",
    "brandName": "CookieJar",
    "baseCategory": "Sweets & Confectionery",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1746791166/products/pim/4066447713480-1543093769/balea-anti-falten-gesichtscreme-q10-lsf-15",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.125,
      "x1": 1.0,
      "y1": 0.875,
      "aspect": 1.3333
    },
    "placements": [
      {
        "shelfId": "K3DS",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6665"
      }
    ],
    "inventory": {
      "quantity": 5
    }
  },
  {
    "gtin": "01000128",
    "name": "Appetite Suppressant",
    "brandName": "HealthyLife",
    "baseCategory": "Health & Wellness",
    "reportedPrice": {
      "amount": 12.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 13.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744980954/products/pim/4066447709889-1906462775/babylove-baby-koerperlotion-ultra-sensitive",
    "imageOutline": {
      "x0": 0.315,
      "y0": 0.0,
      "x1": 0.68,
      "y1": 1.0,
      "aspect": 0.365
    },
    "placements": [
      {
        "shelfId": "K71R",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6672"
      }
    ],
    "inventory": {
      "quantity": 26
    }
  },
  {
    "gtin": "01000129",
    "name": "Snappy Crackers",
    "brandName": "SnackCo",
    "baseCategory": "Snacks",
    "reportedPrice": {
      "amount": 1.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1755907677/products/pim/4062300321335-1598776057/hipp-abendbrei-gute-nacht-dinkelgriess-ab-dem-6-monat",
    "imageOutline": {
      "x0": 0.175,
      "y0": 0.0,
      "x1": 0.82,
      "y1": 1.0,
      "aspect": 0.645
    },
    "placements": [
      {
        "shelfId": "XXBG",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff667f"
      }
    ],
    "inventory": {
      "quantity": 32
    }
  },
  {
    "gtin": "01000130",
    "name": "Happy Meal",
    "brandName": "KidsChoice",
    "baseCategory": "Frozen Foods",
    "reportedPrice": {
      "amount": 4.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 5.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744983758/products/pim/4006000083773-1369264879/nivea-bodylotion-aloe-und-pflege",
    "imageOutline": {
      "x0": 0.325,
      "y0": 0.0,
      "x1": 0.675,
      "y1": 1.0,
      "aspect": 0.35
    },
    "placements": [
      {
        "shelfId": "E0W2",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff668c"
      }
    ],
    "inventory": {
      "quantity": 50
    }
  },
  {
    "gtin": "01000131",
    "name": "App Store Gift Card",
    "brandName": "TechGifts",
    "baseCategory": "Gift Cards",
    "reportedPrice": {
      "amount": 25,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 25,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744962789/products/pim/4066447242553-2052687387/balea-abdeckstift-hautrein-pickel-20-mittlerer-hautton",
    "imageOutline": {
      "x0": 0.125,
      "y0": 0.0,
      "x1": 0.88,
      "y1": 1.0,
      "aspect": 0.755
    },
    "placements": [
      {
        "shelfId": "HVVZ",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6699"
      }
    ],
    "inventory": {
      "quantity": 4
    }
  },
  {
    "gtin": "01000132",
    "name": "Whipped Cream",
    "brandName": "DairyDream",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 1.89,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.09,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744991779/products/pim/4016249151287-581591400/allos-amaranth-maiswaffeln-rosmarin-und-meersalz",
    "imageOutline": {
      "x0": 0.31,
      "y0": 0.0,
      "x1": 0.69,
      "y1": 1.0,
      "aspect": 0.38
    },
    "placements": [
      {
        "shelfId": "JCBY",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff66a6"
      }
    ],
    "inventory": {
      "quantity": 52
    }
  },
  {
    "gtin": "01000133",
    "name": "Wrapper Paper",
    "brandName": "GiftWrap",
    "baseCategory": "Household",
    "reportedPrice": {
      "amount": 2.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744963312/products/pim/4058172922053-2111547795/mivolis-a-z-komplett-depot-ab-50-tabletten-100-st",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.04,
      "x1": 1.0,
      "y1": 0.955,
      "aspect": 1.0929
    },
    "placements": [
      {
        "shelfId": "II59",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff66b3"
      }
    ],
    "inventory": {
      "quantity": 14
    }
  },
  {
    "gtin": "01000134",
    "name": "Applesauce Cups",
    "brandName": "FreshFarms",
    "baseCategory": "Canned & Jarred",
    "reportedPrice": {
      "amount": 3.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744996021/products/pim/8445291643635-933445807/nestle-beba-anfangsmilch-pre-von-geburt-an",
    "imageOutline": {
      "x0": 0.18,
      "y0": 0.0,
      "x1": 0.825,
      "y1": 1.0,
      "aspect": 0.645
    },
    "placements": [
      {
        "shelfId": "4N8Z",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff66c0"
      }
    ],
    "inventory": {
      "quantity": 19
    }
  },
  {
    "gtin": "01000135",
    "name": "Grappa Liqueur",
    "brandName": "ItalianSpirits",
    "baseCategory": "Alcoholic Beverages",
    "reportedPrice": {
      "amount": 24.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 25.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744817051/products/pim/4015537002348-3797673/hammermuehle-brot-5-saatenbrot-simply-seeds-glutenfrei-4-stueck",
    "imageOutline": {
      "x0": 0.065,
      "y0": 0.0,
      "x1": 0.935,
      "y1": 1.0,
      "aspect": 0.87
    },
    "placements": [
      {
        "shelfId": "T80E",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff66cd"
      }
    ],
    "inventory": {
      "quantity": 46
    }
  },
  {
    "gtin": "01000136",
    "name": "Trapped in Paradise Book",
    "brandName": "BookWorld",
    "baseCategory": "Books & Media",
    "reportedPrice": {
      "amount": 9.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 10.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744963666/products/pim/4066447240887-602781997/balea-professional-conditioner-keratin",
    "imageOutline": {
      "x0": 0.255,
      "y0": 0.0,
      "x1": 0.75,
      "y1": 1.0,
      "aspect": 0.495
    },
    "placements": [
      {
        "shelfId": "OTUP",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff66da"
      }
    ],
    "inventory": {
      "quantity": 52
    }
  },
  {
    "gtin": "01000137",
    "name": "Happy Snacks Mix",
    "brandName": "PartyTime",
    "baseCategory": "Snacks",
    "reportedPrice": {
      "amount": 3.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 4.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744752384/products/pim/850278004039-2502309/bondi-sands-applikations-handschuh-zur-selbstbraeunung",
    "imageOutline": {
      "x0": 0.09,
      "y0": 0.0,
      "x1": 0.91,
      "y1": 1.0,
      "aspect": 0.82
    },
    "placements": [
      {
        "shelfId": "MNU9",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff66e7"
      }
    ],
    "inventory": {
      "quantity": 39
    }
  },
  {
    "gtin": "01000138",
    "name": "Capped Mushrooms",
    "brandName": "FreshVeggies",
    "baseCategory": "Produce",
    "reportedPrice": {
      "amount": 2.89,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.09,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745000802/products/pim/4056631003923-126605625/aptamil-anfangsmilch-pre-von-geburt-an",
    "imageOutline": {
      "x0": 0.19,
      "y0": 0.0,
      "x1": 0.81,
      "y1": 1.0,
      "aspect": 0.62
    },
    "placements": [
      {
        "shelfId": "YIAY",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff66f4"
      }
    ],
    "inventory": {
      "quantity": 29
    }
  },
  {
    "gtin": "01000139",
    "name": "Wrapped Candies",
    "brandName": "CandyLand",
    "baseCategory": "Sweets & Confectionery",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1758158634/products/pim/4062300419391-1897205884/hipp-babysanft-baby-waschgel-haut-und-haar-sensitiv",
    "imageOutline": {
      "x0": 0.315,
      "y0": 0.0,
      "x1": 0.695,
      "y1": 1.0,
      "aspect": 0.38
    },
    "placements": [
      {
        "shelfId": "81WM",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6701"
      }
    ],
    "inventory": {
      "quantity": 5
    }
  },
  {
    "gtin": "01000140",
    "name": "Mapped Routes Guide",
    "brandName": "TravelGuides",
    "baseCategory": "Books & Media",
    "reportedPrice": {
      "amount": 7.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 8.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744991807/products/pim/4063528090751-1055193553/wild-stripes-anti-pickel-patches-holo-clear",
    "imageOutline": {
      "x0": 0.185,
      "y0": 0.0,
      "x1": 0.815,
      "y1": 1.0,
      "aspect": 0.63
    },
    "placements": [
      {
        "shelfId": "M3Z9",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff670e"
      }
    ],
    "inventory": {
      "quantity": 29
    }
  }
]